<template>
  <div class="flex flex-row ml-5 mr-5">
    <div
      v-if="budgetDialog.isPreviewRegistered"
      style="width: 888px; height: 568px; top: 50%;left: 50%;border-radius: 24px 0px 24px 24px; position: fixed; z-index:-1; transform: translate(-50%, -50%);"
      class="inline-block overflow-hidden text-left align-middle transition-all transform bg-yellow-lightest"
    />
    <div
      style="width: 870px; height: 490px; top: 55%;left: 50%;border-radius: 24px; z-index:1; position: fixed; transform: translate(-50%, -50%);"
      class="bg-white"
    >
      <app-table v-bind="$attrs" class=" ml-3 mr-3 w-full">
        <template v-slot:table-body>
          <tr
            id="preview-border"
            class="flex border border-collapse border-dashed border-yellow border-t-0 border-l-0 border-r-0 h-10"
            style="height:49px; width:848px"
            v-for="(header, index) in headers"
            :key="index"
          >
            <div class="mt-2 items-center justify-center">
              <td
                style="width:30px; position: relative; top:3px;"
                v-if="!budgetDialog.isPreviewRegistered"
              >
                <approved-icn
                  v-if="header.attr !== 'remarks'"
                  width="20"
                  height="20"
                  class="status-yellow"
                ></approved-icn>
              </td>
              <td
                style="width:30px; position: relative; top:3px;"
                v-else-if="budgetDialog.isPreviewRegistered"
              >
                <approved-icn width="20" height="20"></approved-icn>
              </td>
              <td style="width:180px">
                <span class="-mr-4 text-lg text-yellow font-bold">
                  {{ header.title }}
                </span>
              </td>
              <td v-if="header.attr === 'paymentDate'">
                <span class="text-lg">
                  {{ $filters.dateFormat(currentBudget['paymentDate']) }} |
                  {{ $filters.wareki(currentBudget['paymentDate']) }}
                </span>
              </td>
              <td v-else-if="header.attr === 'amount'">
                <span class="text-lg">
                  {{ currentBudget['amount'].toLocaleString() }}円
                </span>
              </td>
              <td v-else-if="header.attr === 'contentIdList'">
                <span class="text-lg">
                  {{ currentBudget['contentIdList'][0].name }}
                </span>
              </td>
              <td v-else>
                <span class="text-lg">
                  {{ currentBudget[header.attr] }}
                </span>
              </td>
            </div>
          </tr>
        </template>
      </app-table>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'
import { useDialog } from '@/services/useDialog'
import AppTable from '@/components/ui/AppTable'
// import { useBudgetForm } from "@/services/useBudgetForm";
import { useBudgetDialog } from '@/services/useBudgetDialog'
import { useBudgets } from '@/services/useBudgets'

import ApprovedIcn from '@/assets/icons/approved.svg?inline'

export default {
  name: 'BudgetPreview',
  components: {
    AppTable,
    ApprovedIcn,
  },

  setup() {
    const headers = reactive([
      { title: '支払日', attr: 'paymentDate' },
      { title: '支払金額', attr: 'amount' },
      { title: '予算項目', attr: 'contentIdList' },
      { title: '備考', attr: 'remarks' },
    ])

    const { currentBudget } = useBudgets()

    return {
      headers,
      currentBudget,
      ...useDialog(),
      // ...useBudgetForm(),
      ...useBudgetDialog(),
    }
  },
}
</script>
<style lang="scss">
#preview-border:nth-child(4) {
  border: none !important;
}
</style>
